// Module
var code = "<div>\r\n    <router-outlet (activate)=\"onActivate($event)\"></router-outlet>\r\n</div>\r\n\r\n";
// Exports
module.exports = code;